module.exports = __webpack_public_path__ + "static/media/webflow.e80f65a6.png";